(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frostbreak-countdown"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('frostbreak-countdown')) customElements.define('frostbreak-countdown',class extends HTMLElement{
    connectedCallback(){
      clearInterval(this.timer);
      const end=Date.parse(this.dataset.end);
      const output=this.querySelector('[data-time]');
      const tick=()=>{
        const seconds=Math.max(0,Math.floor((end-Date.now())/1000));
        if(!Number.isFinite(end)||seconds===0){this.hidden=true;clearInterval(this.timer);return;}
        this.hidden=false;
        output.textContent=[Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(n=>String(n).padStart(2,'0')).join(':');
      };
      tick();
      if(!this.hidden)this.timer=setInterval(tick,1000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
  } catch(e) { console.error(e); }
})();

})();
